import httpChat from "utils/httpRequest/httpChat";

export const uploadChatAttachments = async (formData) => {
  return httpChat.post("/upload", formData);
};
